export default function () {
    return function (value) {
        if (!value) {
            return value;
        }

        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    };
}



// WEBPACK FOOTER //
// ./src/app/filters/decodeHtml/index.js